<template>
    <div class="personal-information-card">
        <h6 class="personal-information-card__title">{{ $t('Personal information') }}</h6>
        <div v-if="loadingAccount" class="text-center py-5">
            <b-spinner />
        </div>
        <profile-form v-else ref="profileForm" :account="account" />
    </div>
</template>

<script>

import ProfileForm from '@/components/profile/Form.vue';

export default {
    name: 'PersonalInformationCard',
    components: { ProfileForm },
    props: {
        account: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
           loadingAccount: true,
           formData: {
               email: '',
           },

        };
    },
    mounted() {
        setTimeout(() => {
            this.getAccount();
        }, 1000);
    },
    methods: {
        getAccount() {
            try {
                this.loadingAccount = true;
                this.formData.email = this.account.email;
            } catch (error) {
                this.showError(error);
            } finally {
                this.loadingAccount = false;
            }
        }
    }
};
</script>

<style lang="scss">
.personal-information-card {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 16px;

    &__title {
        color: $general-black;
        margin-bottom: 16px;
    }
}
</style>
